export default __webpack_public_path__ + "static/video2-14acdba3c15252ebe58ffdf63d88959a.webm";